module.exports = __webpack_public_path__ + "static/img/risk_bg_h5.9f39f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/risk_bg_h5.png
// module id = tPdM
// module chunks = 34